import NoImage from "../../assets/images/No_Image_Available.jpg";
import { MdOutlineDirectionsWalk } from "react-icons/md";
import { WiDayCloudy } from "react-icons/wi";
import { GiStrong } from "react-icons/gi";
import { BsCloudMoonFill } from "react-icons/bs";
import LazyImage from "../image/LazyLoadImage";
import { motion } from "framer-motion";
import { MapPin, Calendar } from "lucide-react";


const EventComponent = ({ adventure, imageHeigth }) => {
  const getDifficultyColor = (difficulty) => {
    switch (difficulty?.toLowerCase()) {
      case "beginner friendly":
        return "from-mamba-sky-blue to-blue-400";
      case "moderate":
        return "from-mamba-golden to-amber-400";
      case "challenging":
        return "from-orange-500 to-red-500";
      case "extreme":
        return "from-red-600 to-rose-700";
      default:
        return "from-mamba-navy to-slate-700";
    }
  };

  return (
    <motion.div
      whileHover={{ y: -8 }}
      className="w-full relative h-full bg-white rounded-2xl overflow-hidden border-2 border-mamba-sky-blue/20 hover:border-mamba-golden shadow-lg hover:shadow-2xl transition-all group cursor-pointer"
    >
      {/* Image Section */}
      <div className="relative overflow-hidden">
        <motion.div
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.6 }}
          className={imageHeigth === undefined ? "h-[280px]" : "h-[150px]"}
        >
          <LazyImage
            src={adventure?.destination?.images[0]?.image_url ?? NoImage}
            className="w-full h-full object-cover"
          />
        </motion.div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-mamba-navy/60 via-transparent to-transparent" />
        
        {/* Difficulty Badge */}
        {adventure?.destination?.difficulty && (
          <div className="absolute top-4 left-4">
            <div className={`px-3 py-1.5 rounded-full bg-gradient-to-r ${getDifficultyColor(adventure.destination.difficulty)} flex items-center gap-2 shadow-lg`}>
              <GiStrong className="text-white" size={16} />
              <span className="text-xs font-bold font-montserrat text-white uppercase">
                {adventure?.destination?.difficulty}
              </span>
            </div>
          </div>
        )}

        {/* Distance Badge */}
        {adventure?.destination?.distance_in_km && (
          <div className="absolute top-4 right-4">
            <div className="px-3 py-1.5 rounded-full bg-white/95 backdrop-blur-sm flex items-center gap-1.5 shadow-lg">
              <MdOutlineDirectionsWalk className="text-mamba-navy" size={16} />
              <span className="text-xs font-bold font-montserrat text-mamba-navy">
                {adventure?.destination?.distance_in_km} KM
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="p-5">
        {/* Location */}
        <div className="flex items-center gap-2 mb-2">
          <MapPin className="w-4 h-4 text-mamba-sky-blue flex-shrink-0" />
          <h3 className="font-bold font-montserrat text-lg text-mamba-navy line-clamp-1 group-hover:text-mamba-sky-blue transition-colors">
            {adventure?.destination?.name}
          </h3>
        </div>

        {/* Description */}
        <p className="text-slate-600 font-inter text-sm leading-relaxed mb-4 line-clamp-2">
          {adventure?.destination?.description_no_tags?.split(" ").slice(0, 12).join(" ")}...
        </p>

        {/* Date */}
        <div className="flex items-center gap-2 pt-3 border-t border-slate-100">
          <Calendar className="w-4 h-4 text-mamba-golden" />
          <span className="text-sm font-semibold font-montserrat text-mamba-navy">
            {adventure?.start_date}
          </span>
        </div>
      </div>

      {/* Hover Effect Border */}
      <div className="absolute inset-0 rounded-2xl ring-2 ring-mamba-golden ring-opacity-0 group-hover:ring-opacity-100 transition-all duration-300 pointer-events-none" />
    </motion.div>
  );
};

export default EventComponent;
